export default () => {
  const registerByItems = [
    {
      key: 'email',
      label: 'Email'
    }, {
      key: 'phone',
      label: 'Số điện thoại'
    }
  ]

  return {
    registerByItems
  }
}
